import { useMutation } from "@tanstack/react-query";
import { exportTargetareCsv } from "@/api/endpoints/targetare";
import { descarcaFisierText } from "@/utils/targetareFormatting";

export function useExportTargetareCsv() {
  return useMutation({
    mutationFn: exportTargetareCsv,
    onSuccess: (rezultat) => {
      descarcaFisierText(rezultat.continut, rezultat.numeFisier);
    },
  });
}
